<template>
  <IncidentReceivedHeaders />
</template>

<script setup lang="ts">
import IncidentReceivedHeaders from "@/modules/PhishTitan/views/Common/Incidents/IncidentSummary/ReceivedHeaders/index.vue";
import { useI18n } from "vue-i18n";
import { usePageMetaStore } from "@/store/pageMeta.store";

const pageMetaStore = usePageMetaStore();
const { t } = useI18n();

pageMetaStore.setPageTitle({
  title: t("incident-summary"),
});
</script>
